const primary = Object.freeze({
  base: "#704DFA",
  lighten1: "#E2DBFE",
  lighten2: "#C4B6F9",
  darken1: "#A994FC"
});
const secondary = Object.freeze({
  base: "#211EC6",
  darken1: "#100F63",
  darken2: "#15137E"
});
const purple = Object.freeze({
  base: primary
});
const feature = Object.freeze({
  base: "#45588D"
});
const accent = Object.freeze({
  base: "#5DCEF2"
});
const error = Object.freeze({
  base: "#FD2774"
});
const red = Object.freeze({
  base: error
});
const info = Object.freeze({
  base: "#668DF6"
});
const success = Object.freeze({
  base: "#1DC9B7"
});
const green = Object.freeze({
  base: success
});

const warning = Object.freeze({
  base: "#F2C94C"
});
const yellow = Object.freeze({
  base: warning
});

const gray = Object.freeze({
  base: "#9DA0B5", //gray
  lighten1: "#F2F2FB", //highlight
  lighten2: "#DFE1EB", //gray-light
  darken1: "#6C7293", //gray-dark
  darken2: "#444B62", //gray-darker
  accent1: "#F8F8FB", //bg
});

const text = Object.freeze({
  base: gray.darken2
});

export default Object.freeze({
  primary,
  secondary,
  feature,
  accent,
  error,
  red,
  info,
  success,
  warning,
  purple,
  green,
  yellow,
  gray,
  text
});
